import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {getOverageInvoice} from '../../components/staticContent/static-content-requests';
import {Box, Grid, Typography} from '@mui/material';
import {useParams} from 'react-router';
import ExternalInvoiceSkeleton from './ExternalInvoiceSkeleton';
import {withSnackbar} from "../../components/hocs/withSnackbar";
import {getErrorMessageForNonStandardAndStandardResponse} from "../../util/NetworkErrorUtil";
import {styled} from "@mui/material/styles";

const MainContainer = styled(Grid)(({
  paddingTop: '2.86rem',
  paddingRight: '7.79vw',
  paddingLeft: '7.79vw',
}));

const RowGap5 = styled(Grid)(({
  rowGap: '0.36rem',
}));

const WrapContent = styled(Box)(({
  marginTop: '0.5em',
  marginBottom: '2em',
}));

const TitleFont = styled(Typography)(({
  marginTop: '1.43rem',
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: '1.43rem',
  lineHeight: '160%',
  letterSpacing: '0.01rem',
}));

const ContentStyles = styled('div')(({
  ['& .no-display']: {
    display: 'none'
  },
  ['& .ss-tos-platform-title']: {
    fontWeight: '500',
    fontSize: '1.1em'
  },
  ['& .ss-tos-arbitration-note']: {
    textAlign: 'center'
  },
  ['& .ss-tos-title']: {
    fontWeight: '600',
    marginBottom: '1.5em'
  },
  ['& .container']: {
    width: '100% !important',
  },
  ['& .static-page-section p']: {
    textIndent: '0em',
    marginTop: '2em',
  },
  ['& .static-page-section h4']: {
    marginBottom: '-1em'
  },
  ['& div h6']: {
    marginBottom: '2.5em',
    fontWeight: 'bold',
    fontSize: '1.1em'
  },
  ['& div h4']: {
    fontWeight: '500',
    fontSize: '1.1em',
    marginBottom: '0.7em'
  },
  ['& div h5']: {
    fontWeight: 'bold',
    fontSize: '1.1em',
    marginBottom: '1em'
  },
  ['& div p']: {
    fontWeight: '400',
    fontSize: '1.1em',
    lineHeight: '1.5em',
    letterSpacing: '0.01em',
    ['& strong']: {
      fontWeight: '500',
      display: 'inline-block',
      marginBottom: '0.3em'
    }
  },
  ['& div']: {
    marginBottom: '2.5em'
  },
  ['& p, h2, h3']: {
    marginBottom: '2em'
  }
}));

const ExternalInvoice = ({type, snackbarShowMessage}) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  const {invoiceNumber} = useParams();

  useEffect(() => {
    setLoading(true);
    getOverageInvoice(invoiceNumber).then((response) => {
      setLoading(false);
      setContent(response.text);
    }).catch((error) => {
      setLoading(false);
      const errorMessage = getErrorMessageForNonStandardAndStandardResponse(error);
      snackbarShowMessage(`${errorMessage}`, 'error', 15000);
    });
  }, [invoiceNumber, snackbarShowMessage]);

  let headerTitle;
  switch (invoiceNumber) {
    case "unauthorized":
      headerTitle = "You are not authorized to view this page. Please log in as an authorized user.";
      break;
    default:
      break;
  }

  return (
    loading ? <ExternalInvoiceSkeleton type={type}/> : <MainContainer container direction='column'>
      <WrapContent component='header'>
        {!loading && <RowGap5 container direction='column'>
          <TitleFont>
            {headerTitle}
          </TitleFont>
        </RowGap5>
        }
      </WrapContent>
      <ContentStyles dangerouslySetInnerHTML={{__html: content?.toString()}}/>
    </MainContainer>
  );
};

ExternalInvoice.propTypes = {
  type: PropTypes.oneOf(["unauthorized"]),
};

export default withSnackbar(ExternalInvoice);
